import { apiPatch } from '@/api/api.ts'

export interface IReqPatchFallDetectionAssignPerson {
    manager_name: string;
}

export const apiPatchFallDetectionAlertAssignPerson = async (id: number, params: IReqPatchFallDetectionAssignPerson) => {
    return await apiPatch<undefined>(`/alert/falldetection/${id}`, {
        type: '담당자 배정',
        manager_name: params.manager_name
    })
}

export interface IReqPatchFallDetectionProcess {
    task_content: string;
    task_result: string;
}

export const apiPatchFallDetectionAlertProcess = async (id: number, params: IReqPatchFallDetectionProcess) => {
    return await apiPatch<undefined>(`/alert/falldetection/${id}`, {
        type: '확인 완료',
        task_result: params.task_result,
        task_content: params.task_content
    })
} 